import PopoverCalendar from 'components/UI/PopoverCalendarDates';
import ProductOffer from 'model/ProductOffer';
import moment from 'moment';
import {
  AuctionText,
  DateLine,
  DateText,
  InfoSection,
  UntilText,
  ValidityLabel,
} from './ValidityInfo.styled';

export interface ValidityInfoProps {
  product: ProductOffer;
  smallFormat?: boolean;
}

function CalendarComponent({ product }: { product: ProductOffer }) {
  if (product.isLkpOffer) return null;

  const hasRange = Boolean(product.startDate && product.endDate);
  const hasPatterns =
    Array.isArray(product.siteDeliveryPatterns) &&
    product.siteDeliveryPatterns.length > 0;

  if (!hasRange || !hasPatterns) return null;

  return (
    <PopoverCalendar
      startDate={product.startDate}
      endDate={product.endDate}
      siteDeliveryPatterns={product.siteDeliveryPatterns}
    />
  );
}

export function ValidityInfo({
  product,
  smallFormat = false,
}: ValidityInfoProps) {
  if (product.isLkpOffer) {
    const base = product.lkpAuctionDate ?? product.endDate ?? product.startDate;
    if (!base) return null;

    const auctionLabel = smallFormat
      ? moment(base).utc().format('DD/MM')
      : moment(base).utc().format('DD/MM/YYYY');

    return (
      <InfoSection className="validity-info">
        <ValidityLabel>Oferta válida até</ValidityLabel>
        <DateLine>
          <AuctionText>Leilão de </AuctionText>
          <DateText>{auctionLabel}</DateText>
        </DateLine>
      </InfoSection>
    );
  }

  const startFmt = product.startDate
    ? moment(product.startDate).format('DD/MM/YYYY')
    : '';
  const endFmt = product.endDate
    ? moment(product.endDate).format('DD/MM/YYYY')
    : '';
  if (!startFmt && !endFmt) return null;

  return (
    <InfoSection className="validity-info">
      <ValidityLabel>
        Oferta válida até <CalendarComponent product={product} />
      </ValidityLabel>
      <DateLine>
        <DateText>{startFmt}</DateText>
        {endFmt && (
          <>
            <UntilText> até </UntilText>
            <DateText>{endFmt}</DateText>
          </>
        )}
      </DateLine>
    </InfoSection>
  );
}
